module.exports = __webpack_public_path__ + "static/ogembo-e8468c9582ce6444428b6f67316e5adf.jpg";